import React from "react";
import "./Dashboard.css";
import {ReactComponent as ApplicantsIcon} from "../../../assets/user.svg";
import {ReactComponent as JobIcon} from "../../../assets/calender.svg";
import {ReactComponent as CheckIcon} from "../../../assets/check.svg";
import {ReactComponent as StarIcon} from "../../../assets/star.svg";

function Dashboard(){
    return(
      <div className="all"> 
        <div className="overview-container">
            <div className="overview">
                <h2>Overview</h2>
                <p>Hiring pipeline at glance<span className="status-dot"></span><span className="status-text">Live</span></p>
            </div>
            <div className="stats-container">
                <div className="stat-card">
                    <div className="icon-box bleu">
                        <ApplicantsIcon className="icon-user" />
                    </div>
                    <p className="label">Total Applicants</p>
                    <p className="number">2,847</p>
                    <p className="up">🠕 18% vs last month</p>
                </div>
                <div className="stat-card">
                    <div className="icon-box green">
                        <JobIcon className="icon-calender" />
                    </div>
                    <p className="label">Active Job Offers</p>
                    <p className="number">12</p>
                    <p className="up">🠕 3 new this week</p>
                </div>
                <div className="stat-card">
                    <div className="icon-box purple">
                        <CheckIcon className="sah" />
                    </div>
                    <p className="label">Completed Test</p>
                    <p className="number">1,423</p>
                    <p className="up">🠕 241 this week</p>
                </div>
                <div className="stat-card">
                    <div className="icon-box star">
                        <StarIcon className="star-icon" />
                    </div>
                    <p className="label">Top Candidate Score</p>
                    <p className="number">98,4</p>
                    <p className="label">out of 100 pts</p>
                </div>
            </div>
        </div>
        <div className="charts-part">
            <div className="chart-card large">
                <div className="chart-above">
                    <div>
                        <h3>Test Completion Trend</h3>
                        <p>Daily completions — last 30 days</p>
                    </div>
                    <div className="key">
                        <span className="key-item">
                            <span className="dot mavi"></span>Tests
                        </span>
                        <span className="key-item">
                            <span className="dot vers"></span>Hires
                        </span>
                    </div>
                </div>
            </div>
            <div className="chart-card small">
                <div className="chart-above">
                    <div>
                        <h3>Score Distribytion</h3>
                        <p>All candidates</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="candidates-part">
            <div className="candidates-header">
                <div>
                    <h3>Top Candidates</h3>
                    <p>Highest scoring — scroll to explore</p>
                </div>
                <button className="view-all">View all</button>
            </div>
            <div className="candidates">
                <div className="candidates-card">
                    <div className="candidates-profile L">LS</div>
                    <h4>Lamia Sayed</h4>
                    <p className="skill">Backend Systems</p>
                    <p className="score">99.5</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">87% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
                <div className="candidates-card">
                    <div className="candidates-profile E">EP</div>
                    <h4>Elana Petrov</h4>
                    <p className="skill">ML Engineering</p>
                    <p className="score">96.2</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">91% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
                <div className="candidates-card">
                    <div className="candidates-profile C">CV</div>
                    <h4>Carlos Vega</h4>
                    <p className="skill">Cloud Architecture</p>
                    <p className="score">90.3</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">94% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
                <div className="candidates-card">
                    <div className="candidates-profile S">SK</div>
                    <h4>Sara Kader</h4>
                    <p className="skill">UX design</p>
                    <p className="score">90.2</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">80% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
                 <div className="candidates-card">
                    <div className="candidates-profile D">DR</div>
                    <h4>Diego Reyes</h4>
                    <p className="skill">Cloud Architecture</p>
                    <p className="score">85.5</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">84% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
                <div className="candidates-card">
                    <div className="candidates-profile K">KM</div>
                    <h4>Kofi Menash</h4>
                    <p className="skill">Full-Stack</p>
                    <p className="score">83.3</p>
                    <p className="score-label">SCORE</p>
                    <span className="match">82% match</span>
                    <button className="candidates-profile-btn">View Profile</button>
                </div>
            </div>
        </div>
        <div className="recent-tests-part">
            <div className="tests-header">
                <div>
                    <h3>Recent Job Tests</h3>
                    <p>Active skill challenges</p>
                </div>
                <button className="new-test">+ New Test</button>
            </div>
            <div className="tests">
                <div className="titles">
                    <span>JOB TITLE</span>
                    <span>SKILLS</span>
                    <span>PARTICIPANTS</span>
                    <span>AVG SCORE</span>
                    <span>STATUS</span>
                </div>
                <div className="row">
                    <span>Senior Frontend Developer</span>
                    <div className="test-skills">
                        <span className="tag1">React</span>
                        <span className="tag2">TypeScript</span>
                        <span className="tag3">CSS</span>
                    </div>
                    <span>248</span>
                    <span>74.2</span>
                    <span className="status open">● Open</span>
                </div>
                <div className="row">
                    <span>Backend Systems Engineer</span>
                    <div className="test-skills">
                        <span className="tag1">Node.js</span>
                        <span className="tag2">PostgreSQL</span>
                        <span className="tag3">Docker</span>
                    </div>
                    <span>183</span>
                    <span>69.8</span>
                    <span className="status open">● Open</span>
                </div>
                <div className="row">
                    <span>Data Analysis Challenge</span>
                    <div className="test-skills">
                        <span className="tag1">Python</span>
                        <span className="tag2">SQL</span>
                        <span className="tag3">Pandas</span>
                    </div>
                    <span>127</span>
                    <span>78.4</span>
                    <span className="status open">● Open</span>
                </div>
                <div className="row">
                    <span>Cloud Architecture</span>
                    <div className="test-skills">
                        <span className="tag1">AWS</span>
                        <span className="tag2">Kubernetes</span>
                    </div>
                    <span>94</span>
                    <span>71.1</span>
                    <span className="status draft">● Draft</span>
                </div>
                <div className="row">
                    <span>UX Design Sprint</span>
                    <div className="test-skills">
                        <span className="tag1">Figma</span>
                        <span className="tag2">Research</span>
                    </div>
                    <span>211</span>
                    <span>80.6</span>
                    <span className="status closed">● Closed</span>
                </div>
                <div className="row">
                    <span>ML Engineering</span>
                    <div className="test-skills">
                        <span className="tag1">Python</span>
                        <span className="tag2">TensorFlow</span>
                    </div>
                    <span>76</span>
                    <span>66.3</span>
                    <span className="status open">● Open</span>
                </div>
            </div>
        </div>
      </div> 
    );
}
export default Dashboard;